module.exports = __webpack_public_path__ + "static/img/online_pic1.29fc06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_pic1.jpg
// module id = AOCh
// module chunks = 21